import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal }           from '@ng-bootstrap/ng-bootstrap';
import { TranslateService }         from '@ngx-translate/core';

import { CustomerPaymentMethodModel } from './models/customer-payment.method';
import { CustomerPaymentModel }       from './models/customer-payment';
import { Table }                      from '../table/types/table';

@Component({
  selector   : 'customer-payments-methods',
  template: require('./customer-payments.methods.component.html')
})
export class CustomerPaymentsMethodsComponent implements OnInit {
  @Input() payment: CustomerPaymentModel;

  paymentMethods: Array<CustomerPaymentMethodModel>;

  tableSettings : Table = {
    columns: [
      {
        classes: 'text-left',
        field  : 'payment_type',
        header : {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.PAYMENT_METHOD')
        }
      },
      {
        classes: 'text-left',
        field  : 'reference',
        header : {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.REFERENCE')
        }
      }
    ],
    empty: {
      text: this.translateService.instant('COMPANY_SPACE.LISTS.GRID.NO_PAYMENT_METHODS')
    },
    pagination: {
      enabled: false
    },
    sorting: {
      enabled: false
    },
    static: true
  };

  constructor (
    public  activeModal     : NgbActiveModal,
    private translateService: TranslateService
  ) {}

  ngOnInit() : void {
    this.paymentMethods = this.payment.customer_payment_methods_attributes;
  }
}
